import { DetailBox } from '@octano/global-ui';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';
import GoBackToListButton from '../../../components/buttons/GoBackToListButton';
import { TranslationsKeys } from '../../../locales/translations';
import { useStudentRiskEvaluationSessionDetails } from '../loaders/StudentRiskEvaluationSessionDetailsLoader';

const StudentRiskEvaluationSessionsHeader = () => {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_RISK_EVALUATION_SESSIONS_STUDENTS,
  );
  const data = useStudentRiskEvaluationSessionDetails();

  const columns = useMemo(() => {
    return [
      {
        title: t('box.name'),
        body: data?.name,
      },
      {
        title: t('box.dates'),
        body: `${dayjs(data?.startAt).format('DD/MM/YYYY')} - ${dayjs(
          data?.endAt,
        ).format('DD/MM/YYYY')}`,
      },
      {
        title: t('box.year'),
        body: `${data?.year ?? ''}`,
      },
      {
        title: t('box.period'),
        body: `${data?.period?.name ?? data?.periodId ?? ''}`,
      },
      {
        title: t('box.school'),
        body: `${data?.school?.name ?? data?.schoolId ?? ''}`,
      },
    ];
  }, [data, t]);

  return (
    <Container fluid>
      <Row className="pb-4 gutters-filters">
        <Col xs={12} className="pt-3" md={6}>
          <GoBackToListButton />
        </Col>
        <Col xs={12} md={6}>
          <div>
            <DetailBox columns={columns} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default StudentRiskEvaluationSessionsHeader;
